import imports from './imports';

export default {
	imports
};
